//src/pages/REG/REG300F1.jsx
import React, {useEffect, useState} from 'react';
import style from "./REG300F1.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";

import Render1Html from './REG300F2';
import Render2Html from './REG300F3';
import Render3Html from './REG300F4';
import Render4Html from './REG300F5';
import Render5Html from './REG300F6';
import {postData} from 'utils/TransactionUtil';
import regJson from 'assets/json/frmReg_data.json';
import styleCom from "./REGCOM.module.scss";


/* TAB 구성 */
function Sidebar({ tabs, activeTabId, onTabClick }) {
    return (
        <ul className={style.tabList}>
            {tabs.map((tab) => (
                <li key={tab.id} className={`${style.tabItem} ${activeTabId === tab.id ? style.activeTab : ''}`}
                    onClick={() => onTabClick(tab.id)}
                >
                    {tab.label}
                </li>
            ))}
        </ul>
    );
}


/* ************************************************************************************
*************************************************************************************** */

const REG300F1 = ({navBar: NavBar, mstId, hsptCd}) => {

    const [workId, setWorkId] = useState(mstId);
    const [workHsptCd, setWorkHsptCd] = useState(hsptCd);

    const [dsDtl,setDsDtl] = useState([]);

    const [dsMst,setDsMst] = useState([]);
    const [dsBaseline,    setDsBaseline] = useState([]);
    const [dsClinialData, setDsClinialData] = useState([]);
    const [dsCartBp  , setDsCartBp] = useState([]);

    const initObjBaseline = [
        {
             mstId: workId ,hsptCd: workHsptCd
            ,lowSes:"" ,height:"" ,weight:"" ,smokingYn:""
            ,alcoholYn:"" ,dyslipidemiaYn:"" ,afYn:"" ,ckdYn:""
            ,dialysisYn:"" ,priorMiYn:"" ,priorStrokeYn:"" ,priorHfAdmYn:""
            ,osys1:"" ,odia1:"" ,opr1:"" ,osys2:"" ,odia2:"" ,opr2:"" ,aceiYn:""
            ,aceiName:"" ,aceiDose:"" ,arbYn:"" ,arbName:""
            ,arbDose:"" ,entrestoYn:"" ,entrestoDose:"" ,bbYn:"" ,bbName:"",bbDose:""
            ,ccbYn:"" ,ccbName:"",ccbDose:"",diureticsYn:"",diureticsName:"",diureticsDose:""
            ,sglt2iYn:"",sglt2iName:"",sglt2iDose:"",llaYn:"",ohaYn:"",insulinYn:""
            ,hb:"",wbc:"",plt:"",cr:"",ast:"",alt:"",totalChol:""
            ,ldlC:"",hdlC:"",triglyceride:"",glucose:"",hba1c:"",hscrp:""
            ,ntProbnp:"",uricAcid:"",ualbumin:"",ucreatinine:"",uacr:""
        }
    ];


    const activeFlagObj = [
         {mapCd: "M00002", chkFlag:"matched",    chkVal: "10", tarId:"M00003", tarFlag:0, tarVal:""}
        ,{mapCd: "M00002", chkFlag:"notMatched", chkVal: "10", tarId:"M00003", tarFlag:1, tarVal:""}
    ];

    //폼 로드
    useEffect(() => {
        svcSubjectData(workId).then(() => {
        });
    }, []);



/* Call Service ****************************************************************************** */

    async function svcSubjectData() {
        let param = {
              mstId : workId
             ,hsptCd: workHsptCd
        }
        let result = await postData("/RED/getSubjectData", param);
        setDsMst(result.outDs1);
        //const rowCount = Array.isArray(result.outDs2) ? result.outDs2.length : 0;

        if(result.outDs2 && result.outDs2.length > 0){
            setDsBaseline(result.outDs2);
        }else {
            setDsBaseline(initObjBaseline);
        }

        if(result.outDs3 && result.outDs3.length > 0){
            setDsClinialData(result.outDs3);
        }
        if(result.outDs4 && result.outDs4.length > 0){
            setDsCartBp(result.outDs4);
        }



    }

    async function svcSaveData(dsMstCopy) {

        if(getMstValue('signatureYn') === 'Y') {
            //예외처리 - 1 서명
            toast({ type: 'warning', message: '서명이 완료된자료는 저장할 수 없습니다.', opt: { position: "top-center"} });
            return;
        }else if(getMstValue("activeStat")==="D"){
            //예외처리 - 2 비활성화된 자료
            toast({ type: 'warning', message: '비활성화된 자료는 저장할 수 없습니다.', opt: { position: "top-center"} });
            return;
        }

        const dsMstParam = dsMstCopy;
        // const baseParam = dsBaseline;

        const paramList = {
            in_dsMst: dsMstParam
           ,in_dsBaseline: dsBaseline
        };
        let result = await postData("/RED/saveSubjectData", paramList);
        if(result==="SUCCESS") {
            toast({ type: 'info', message: '저장되었습니다.', opt: { position: "top-center"} });
        }else{
            toast({ type: 'error', message: '저장에 실패하였습니다..', opt: { position: "top-center"} });
        }



    }


/* ****************************************************************************** Call Service */

/* User Function ****************************************************************************** */

    //데이터 get, set
    const getMstValue = (colName) =>{
        const targetItem = dsMst.find(item => item.mstId === workId);
        if (targetItem && targetItem.hasOwnProperty(colName)) {
            return targetItem[colName];
        } else {
            return ""; // 또는 다른 적절한 값 (null, 에러 처리 등)
        }
    }
    const setMstValue = (colName, newValue) => {
        setDsMst(prevData =>
            prevData.map(item =>
                item.mstId === workId? { ...item, [colName]:newValue } : item
            )
        );
    };

    const getBaseVal = (colName) =>{
        const targetItem = dsBaseline.find(item => item.mstId === workId);
        if (targetItem && targetItem.hasOwnProperty(colName)) {
            return targetItem[colName];
        } else {
            return ""; // 또는 다른 적절한 값 (null, 에러 처리 등)
        }
    }
    const setBaseVal = (colName, newValue) => {
        setDsBaseline(prevData =>
            prevData.map(item =>
                item.mstId === workId? { ...item, [colName]:newValue } : item
            )
        );
    };



    //==========================================================================

    // const saveChkBaseline = () => {
    //     const chkBaselineObj = regJson.chkObjBaseline;
    //     chkBaselineObj.
    //
    //
    //     return
    // }
    //

    //데이터 get, set
    const getDtlValue = (mapCd, colName='itmRslt') =>{
        const targetItem = dsDtl.find(item => item.mapCd === mapCd);
        if (targetItem && targetItem.hasOwnProperty(colName)) {
            return targetItem[colName];
        } else {
            return ""; // 또는 다른 적절한 값 (null, 에러 처리 등)
        }
    }
    const setDtlValue = (mapCd, newValue, colName='itmRslt') => {
        setDsDtl(prevData =>
            prevData.map(item =>
                item.mapCd === mapCd? { ...item, [colName]:newValue } : item
            )
        );

    };

    const initialItemState = (mapCd, value="") =>{

        const matchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='notMatched'
        );

        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                }
            });
        }else if(notMatchedObj.length > 0){
            // if(mapCd==='M00010'){
            //     console.log(mapCd + " : ");
            // }

            notMatchedObj.forEach(item => {
                setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                // if(item.mapCd ==='M00010'){
                //     console.log("수행");
                //     console.log(item.tarFlag);
                // }
            });
        }

    }

    const formatDate = (dateString) => {
        return `${dateString.slice(0, 4)}-${dateString.slice(4, 6)}-${dateString.slice(6, 8)}`;
    };


    const getStatDisplay = (statCd) =>{
        let resultStat = '';
        switch (statCd) {
            case 'A':  resultStat = '🔴';  break;
            case 'B':  resultStat = '🔵';  break;
            case 'C':  resultStat = '🟢';  break;
            default:
                break;
        }

        return resultStat;
    }


    //Tab 구성
    const tabs = [
        { id: 'T0', label: 'Demographics',  content: 'Demographics' },
        { id: 'T1', label: 'Baseline',      content: 'Baseline' },
        // { id: 'T2', label: 'Clinical Data',  content: 'Clinical Data Content' },
        { id: 'T3', label: 'CART BP', content: 'CART BP 조회' },
        { id: 'T4', label: 'End Study ' + getStatDisplay(getMstValue('task99Stat')), content: 'End Study' }
    ]

    const updateWorkState = () => {
        // dsMst 복사본 만들기 (깊은 복사, 필요한 깊이만큼)
        const dsMstCopy = dsMst.map(item => ({ ...item }));
        // 내부 함수: setMstValue_new처럼 dsMstCopy 수정
        const setMstValue_new = (colName, newValue) => {
            for (let item of dsMstCopy) {
                if (item.mstId === workId) {
                    item[colName] = newValue;
                    break;
                }
            }
        };

        const getMstValue_new = (colName) => {
            const target = dsMstCopy.find(item => item.mstId === workId);
            return target && target.hasOwnProperty(colName) ? target[colName] : "";
        };

        let task99Flag = '';
        if(getMstValue('signatureYn') === 'Y' && getMstValue('studyEndDt') != '' && getMstValue('studyEndStat') != '' ){
            task99Flag = 'C';
        }else{
            task99Flag = 'A';
        }
        setMstValue_new('task99Stat', task99Flag)

        setDsMst(dsMstCopy);
        return dsMstCopy


    }

/* ****************************************************************************** User Function */

/* Call Service ****************************************************************************** */



/* TabPage Area ****************************************************************************** */


    const [activeTabId, setActiveTabId] = useState(tabs[0]?.id || null);
    // 활성화된 탭의 내용을 효율적으로 찾기 위해 useMemo 사용(activeTabId가 변경될 때만 다시 계산)
    // 탭 클릭 핸들러
    const handleTabClick = (tabId) => {
        setActiveTabId(tabId);
    };

    function mainContent(contentId) {
        switch (contentId) {
            case "T0":
                return (
                    <Render1Html contentId={contentId}     activeFlagObj={activeFlagObj}
                                 getMstValue={getMstValue} setMstValue={setMstValue}
                                 getDtlValue={getDtlValue} setDtlValue={setDtlValue}/>
                );
            case "T1":
                return (
                    <Render2Html contentId={contentId}
                                 getBaseVal={getBaseVal} setBaseVal={setBaseVal}
                    />
                );
            case "T2":
                return (
                    <Render3Html contentId={contentId} workId={workId} workHsptCd={workHsptCd}
                                 dsClinialData={dsClinialData} setDsClinialData={setDsClinialData}
                    />
                );
            case "T3":
                return (
                    <Render4Html contentId={contentId} workId={workId} workHsptCd={workHsptCd}
                                 dsCartBp={dsCartBp} setDsCartBp={setDsCartBp}
                    />
                );

            case "T4":
                return (
                    <Render5Html contentId={contentId} workId={workId} workHsptCd={workHsptCd}
                                 dsCartBp={dsCartBp} setDsCartBp={setDsCartBp}
                                 getMstValue={getMstValue} setMstValue={setMstValue}
                                 getDtlValue={getDtlValue} setDtlValue={setDtlValue}

                    />
                );

            default:
                return null;
        }
    }

/* ****************************************************************************** TabPage Area */

/* Event ****************************************************************************** */
    const handleMainSave = () => {
        const dsMstCopy = updateWorkState();  //상태값 체크

        svcSaveData(dsMstCopy).then(() => {

        });



    }

/* ****************************************************************************** Event */


    return (
        <>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Primary" size="md" addStyle={{width: "58px", height: "40px"}}
                            onClick={()=> handleMainSave()}>
                        저장
                    </Button>
                </div>
                {/*대상자 정보*/}
                <table className={style.info_table} style={{height: "42px", marginBottom:"-10px"}}>
                    <tbody>
                    <tr>
                        <td className={style.info_text_1}> Study ID</td>
                        <td className={style.info_text_2}>{getMstValue("studyId")}</td>
                        <td>
                            <div className={style.verticalLine}/>
                        </td>

                        <td className={style.info_text_1}> Initial</td>
                        <td className={style.info_text_2}>{getMstValue("initial")}</td>
                        <td>
                            <div className={style.verticalLine}/>
                        </td>

                        <td className={style.info_text_1}> Sex/Age</td>
                        <td className={style.info_text_2}>{getMstValue("sex")}/{getMstValue("age")}</td>
                        <td>
                            <div className={style.verticalLine}/>
                        </td>
                        <td className={style.info_text_1}> Enroll date</td>
                        <td className={style.info_text_2}>{formatDate(getMstValue("enrollDt"))}</td>

                    </tr>
                    </tbody>
                </table>
            </NavBar>
            <div className={styleCom.root_wrap}>
                {/*컨텐츠 영역*/}
                <div className={style.container}>
                    {/* 좌측 탭 목록 영역 */}
                    <div className={style.sidebar}>
                        <Sidebar
                            tabs={tabs}
                            activeTabId={activeTabId} // 활성화된 탭 ID 전달
                            onTabClick={handleTabClick} // 탭 클릭 핸들러 전달
                        />
                    </div>

                    {/* 우측 컨텐츠 영역 */}
                    <div className={style.contentArea} style={{width: "1300px"}}>
                        {mainContent(activeTabId)}
                    </div>
                </div>

            </div>
        </>


    )
        ;
};


export default REG300F1;
